export type AskResponse = {
  answer: string
  citations: Citation[]
  error?: string
  message_id?: string
  feedback?: Feedback
  order_id : number | undefined
  MessageCategory : string | undefined
}

export type Citation = {
  part_index?: number
  content: string
  id: string
  title: string | null
  filepath: string
  url: string
  metadata: string | null
  chunk_id: string | null
  reindex_id: string | null
  reference : string | null
  documentNumber: string | null
  partId: string | null
  languageCode: string | null
  fileExtension: string | null
  revision: string | null
  section: string | null
  page_from: string | null
  page_to: string | null
}

export type ToolMessageContent = {
  citations: Citation[]
  intent: string
}

export type ChatMessage = {
  id: string
  role: string
  content: string
  end_turn?: boolean
  date: string
  feedback?: Feedback
  context?: string
}

export type Conversation = {
  id: string
  title: string
  messages: ChatMessage[]
  date: string
}

export type BotConversations = {
  id: string
  title: string
  messages: BotResponse[]
  date: string
  token:string
  bconvid : string
  dataSource:string
}

export enum ChatCompletionType {
  ChatCompletion = 'chat.completion',
  ChatCompletionChunk = 'chat.completion.chunk'
}

export type ChatResponseChoice = {
  messages: ChatMessage[]
}

export type ChatResponse = {
  id: string
  model: string
  created: number
  object: ChatCompletionType
  choices: ChatResponseChoice[]
  history_metadata: {
    conversation_id: string
    title: string
    date: string
  }
  error?: any
}

export type ConversationRequest = {
  messages: ChatMessage[]
}

export type UserInfo = {
  access_token: string
  expires_on: string
  id_token: string
  provider_name: string
  user_claims: any[]
  user_id: string
}

export enum CosmosDBStatus {
  NotConfigured = 'CosmosDB is not configured',
  NotWorking = 'CosmosDB is not working',
  InvalidCredentials = 'CosmosDB has invalid credentials',
  InvalidDatabase = 'Invalid CosmosDB database name',
  InvalidContainer = 'Invalid CosmosDB container name',
  Working = 'CosmosDB is configured and working'
}

export type CosmosDBHealth = {
  cosmosDB: boolean
  status: string
}


export type BTN = {
  type: string;
  title: string;
  value: string;
}

export enum ChatHistoryLoadingState {
  Loading = 'loading',
  Success = 'success',
  Fail = 'fail',
  NotStarted = 'notStarted'
}

export type ErrorMessage = {
  title: string
  subtitle: string
}

export type UI = {
  title: string
  chat_title: string
  chat_description: string
  logo?: string
  chat_logo?: string
  show_share_button?: boolean
}

export type FrontendSettings = {
  auth_enabled?: string | null
  feedback_enabled?: string | null
  ui?: UI
  sanitize_answer?: boolean
}

export enum Feedback {
  Neutral = 'neutral',
  Positive = 'positive',
  Negative = 'negative',
  MissingCitation = 'missing_citation',
  WrongCitation = 'wrong_citation',
  OutOfScope = 'out_of_scope',
  InaccurateOrIrrelevant = 'inaccurate_or_irrelevant',
  OtherUnhelpful = 'other_unhelpful',
  HateSpeech = 'hate_speech',
  Violent = 'violent',
  Sexual = 'sexual',
  Manipulative = 'manipulative',
  OtherHarmful = 'other_harmlful'
}


export type BotResponse = {
  orderId?: number 
  card: any
  feedback: Feedback | undefined
  type: string
  id: string
  timestamp: string
  date: string
  channelId: string
  from: From
  conversation: Conversation
  text: string
  inputHint: string
  role: string
  context: string
  content: any
  messageType: string
  oAuth? : OAuth
  token : string
  streamUrl : string
  MessageCategory?:string
}

export type From = {
  id: string
  name: string
}

export type BotConversation = {
  id: string
}

export type Message = { content: string; date: string; id: string; role: string; };
export type HistoryMetadata = { conversation_id: string; date: string; title: string; };
export type Data = { history_metadata: HistoryMetadata; messages: Message[]; };

export interface CardAction {
  type: string;
  title: string;
  value: string;
}

export interface OAuth {
  contentType: "application/vnd.microsoft.card.oauth";
  content: {
    text?: string;
    connectionname: string;
    buttons?: CardAction[];
  };
}

// New Api implementation

export interface ListAvailableAgentsResponse {
  agents_availability: {
      [key: string]: "available" | "unavailable";
  };
}

export interface NewConversationRequest {
  agent: string;
}

export interface NewConversationResponse {
  adaptive_card: string | null;
  conversation_id: string;
  message: string | null;
}

export interface PostFunctionRequest {
  function: string;
  parameters: object;
}

export interface PostMessageRequest {
  user_message: string;
  timestamp: string;
}

export interface AvailableAgentsList {
  agents_availability: AgentsAvailability
}

export interface AgentsAvailability {
  structured: string
  unstructured: string
  pgga_lessons_learned: string
  pgtr_engineering: string
  scm: string
  finance: string
  lc_nuclear?: string
  hvproject?: string
}

interface Properties {
  is_citations: boolean;
}

interface MessageResponse {
  conversation_id: string;
  query_id: string;
  msg_id: string;
  adaptive_card: any; 
  message: string; 
  properties: Properties;
}

export interface UserMessage {
  user_message: string;
  timestamp: string;
}

export interface ConversationMessage {
  conversation_id: string
  query_id: string;
  msg_id: string;
  adaptive_card: any; 
  message: string;
  properties: any;
}

export enum ClientSources {
  Browser = 'Browser',
  CDSe = 'CDSe',
  CDSm = 'CDSm',
  CDSmPrime = 'CDSm-Prime',
  CDSmCreo = 'CDSm-Creo'
}